<script>
import Swal from 'sweetalert2'

import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Helper from '@/helpers/helper';

import { ref } from "vue";


/**
 * Dashboard Component
 */
export default {
    setup() {
        const doesAddOpen = ref(false);
        const doesEditOpen = ref(false);
        const doesDeleteOpen = ref(false);
        const doesLoadingOpen = ref(false)

        return {
          doesAddOpen,
          doesEditOpen,
          doesDeleteOpen,
          doesLoadingOpen
        };
    },
    page: {
    title: "aggregators summaries",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "aggregators summaries",
      items: [
        {
          text: "Menu",
        },
        {
          text: "aggregators summaries",
          active: true,
        },
      ],
      errors: [],
      aggregator_summarie: {},
      aggregator_summaries: [],  
      methods: [],   
      aggregators: [],      
      
      capital: 0,
      deposit: 0,
      withdraw: 0,
      depositProfit: 0,
      withdrawProfit: 0,
      depositFees: 0,
      withdrawFees: 0,
      credit: 0,
      debit: 0,
      fees: 0,
      profit: 0,
      aggregator_id: "",
      
      loading: false,
      status: 201,
    };
  },
  methods: {
    loadList() {
      fetch(Helper.route('aggregators-summaries'), Helper.requestOptionsJSON())
      .then(response => {
          Helper.tokenChecker(response.status)
          return response.json()
      })
      .then(data => {
        this.aggregator_summaries = data        
        this.doesLoadingOpen = false
      })
    },
    loadMethods() {
      fetch(Helper.route('methods'), Helper.requestOptionsJSON())
      .then(response => {
          Helper.tokenChecker(response.status)
          return response.json()
      })
      .then(data => {
        this.methods = data
      })
    },
    loadAggregators() {
      fetch(Helper.route('aggregators'), Helper.requestOptionsJSON())
      .then(response => {
          Helper.tokenChecker(response.status)
          return response.json()
      })
      .then(data => {
        
        this.aggregators = data
        this.doesLoadingOpen = false

        console.log("aggregators :", this.aggregators);
        
      })
    },
    addItem() {
      this.loading = true
      this.errors = []
      let body = {
        "capital": this.capital,
        "deposit": this.deposit,
        "withdraw": this.withdraw,
        "depositProfit": this.depositProfit,
        "withdrawProfit": this.withdrawProfit,
        "depositFees": this.depositFees,
        "withdrawFees": this.withdrawFees,
        "credit": this.credit,
        "debit": this.debit,
        "fees": this.fees,
        "profit": this.profit,
        "aggregator": {
          "id": this.aggregator_id
        }
      }
      
      fetch(Helper.route('aggregators-summaries'), Helper.requestOptionsJSON("POST", body))
      .then(response => {
          //Helper.tokenChecker(response.status)
          this.status = response.status
          return response.json()
      })
      .then(data => {
        console.log(data);
        
        this.loading = false
        if (this.status == 201) {
          this.doesAddOpen = false
          this.aggregator_summaries.push(data) 
          Swal.fire("Aggregator Summaries ajouter !", "Aggregator Summaries a été enregistré avec succès.", "success");
        } else {
            this.errors.name = Helper.getError(data, "aggregator_summarie_name")
        }
      })
      .catch(error => {
        console.log(error);
        this.loading = false
      })
    },
    editItem() {
      this.loading = true
      this.errors = []
      let body = {
        "capital": this.capital,
        "deposit": this.deposit,
        "withdraw": this.withdraw,
        "depositProfit": this.depositProfit,
        "withdrawProfit": this.withdrawProfit,
        "depositFees": this.depositFees,
        "withdrawFees": this.withdrawFees,
        "credit": this.credit,
        "debit": this.debit,
        "fees": this.fees,
        "profit": this.profit,
        "aggregator": {
          "id": this.aggregator_id
        }
      }

      fetch(Helper.route('aggregators-summaries/'+this.aggregator_summarie.id), Helper.requestOptionsJSON("PUT", body))
      .then(response => {
          Helper.tokenChecker(response.status)
          this.status = response.status
          return response.json()
      })
      .then(data => {
        console.log(this.status);
        this.loading = false
        if (this.status == 200) {
          this.doesEditOpen = false
          this.aggregator_summaries = this.aggregator_summaries.map(i => i.id !== this.aggregator_summarie.id ? i : data)
          Swal.fire("Aggregator Summaries modifier !", "Aggregator Summaries a été modifié avec succès.", "success");
        } else {
            this.errors.name = Helper.getError(data, "aggregator_summarie_name")
        }
      })
      .catch(error => {
        console.log(error);
        this.loading = false
      })
    },
    deleteIt() {
      this.loading = true
      fetch(Helper.route('aggregators-summaries/'+this.aggregator_summarie.id), Helper.requestOptions("DELETE"))
      .then(response => {
          Helper.tokenChecker(response.status)
          this.status = response.status
          return response.text()
      })
      .then(data => {
        console.log(this.status);
        console.log(data);
        if (this.status == 200) {
          this.aggregator_summaries = this.aggregator_summaries.filter(i => i.id !== this.aggregator_summarie.id)
          this.loading = false
          this.aggregator_summarie = null
          this.doesDeleteOpen = false
          Swal.fire("Aggregator Summaries supprimer !", "Aggregator Summaries a été supprimé avec succès.", "success");
        } else {
          Swal.fire("Aggregator Summaries non supprimer ?", "La suppression n'a pas marché, veuillez réessayez plus tard.", "error");
        }
      })
    },
    initItem(aggregator_summarie, action="edit") {
      this.aggregator_summarie = aggregator_summarie
      this.initData(aggregator_summarie)
      if (action == "delete") {
        this.doesDeleteOpen = true
      } else {
        this.doesEditOpen = true
      }
    },
    initData(item = null) {
      this.amount = item != null ? item.amount : ""
      this.type = item != null ? item.type : ""
      this.balance = item != null ? item.balance : ""
      this.available = item != null ? item.available : ""
      this.aggregator_id = item != null ? item?.aggregator?.id : ""
      this.method_id = item != null ? item?.method?.id : ""
    }
  },
  mounted() {
    this.loadList()
    this.loadMethods()
    this.loadAggregators()
    this.doesLoadingOpen = false
  },
  watch: {
    doesAddOpen: function() {
      this.errors = []
      if (!this.doesAddOpen) {
        this.initData(null)
      }
    },
    doesEditOpen: function() {
      this.errors = []
      if (!this.doesEditOpen) {
        this.initData(null)
        this.aggregator_summarie = null
      }
    },
    doesDeleteOpen: function() {
      if (!this.doesDeleteOpen) {
        this.initData(null)
        this.aggregator_summarie = null
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row" v-show="status != 403">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des aggregateurs summaries</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <code>aggregateurs summaries</code>.
            </p>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Aggreagateur</th>
                    <th>Capital</th>
                    <th>Deposit</th>
                    <th>Retrait</th>
                    <th>Deposit Profit</th>
                    <th>Withdraw Profit</th>
                    <th>Deposit Fees</th>
                    <th>Withdraw Fees</th>
                    <th>Credit</th>
                    <th>Fees</th>
                    <th>Profit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(aggregator_summarie, i) in aggregator_summaries" :key="aggregator_summarie.id">
                    <th scope="row">{{ i + 1 }}</th>
                    <td>
                      {{ aggregator_summarie?.aggregator?.name }}
                    </td>
                    <td>
                      {{  Number(aggregator_summarie?.capital) }}
                    </td>
                    <td>
                      {{ Number( aggregator_summarie?.deposit) }}
                    </td>
                    <td>
                      {{  Number(aggregator_summarie?.withdraw) }}
                    </td>
                    <td>
                      {{ Number( aggregator_summarie?.depositProfit) }}
                    </td>
                    <td>
                      {{  Number(aggregator_summarie?.withdrawProfit) }}
                    </td>
                    <td>
                      {{  Number(aggregator_summarie?.depositFees) }}
                    </td>
                    <td>
                      {{  Number(aggregator_summarie?.withdrawFees) }}
                    </td>
                    <td>
                      {{ Number( aggregator_summarie?.credit) }}
                    </td>
                    <td>
                      {{  Number(aggregator_summarie?.debit) }}
                    </td>
                    <td>
                      {{  Number(aggregator_summarie?.fees) }}
                    </td>
                    <td>
                      {{ aggregator_summarie?.profit }}
                    </td>
                    <td class="hstack">
                        <b-button class="btn-sm ms-2" @click="initItem(aggregator_summarie, 'edit')" variant="success">
                            <i class="bx bx-edit font-size-16 align-middle mx-1"></i>
                        </b-button>
                        <b-button variant="danger" @click="initItem(aggregator_summarie, 'delete')" class="ms-2 btn-sm">
                          <i class="bx bx-trash font-size-16 align-middle mx-1"></i>
                        </b-button>
                        <router-link :to="'/aggregator_summarie/' + aggregator_summarie.id">
                        <b-button class="btn-sm ms-2 rounded-pill px-2" variant="primary">
                          Details
                        </b-button>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            
          </div>
        </div>
      </div>
    </div>

    
    

    <div v-show="status === 403">
      <h3 class="text-danger text-center my-5">Réserver à l'administrateur principal</h3>
    </div>

    <!-- LOADING MODAL -->
    <b-modal v-model="doesLoadingOpen" id="modal-center" centered size="md" title="Chargement..."
      title-class="font-18" hide-footer>
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>

    <!-- ADD MODAL -->
    <b-modal
        v-model="doesAddOpen"
        id="modal-center"
        centered
        size="lg"
        title="Ajouter un aggregateur Transaction"
        title-class="font-18"
        hide-footer
        >
        <form @submit.prevent="addItem()">
          <div class="row">
            
            <div class="col-md-6 mb-3">
              <label for="">Montant</label>
              <input type="text" required v-model="amount" class="form-control">
              <span class="text-danger mt-2" v-if="errors.amount">{{ errors.amount }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Type</label>
              <select required v-model="type" class="form-control">
                <option value="deposit">Dépôt</option>
                <option value="withdraw">Retrait</option>
              </select>
              <span class="text-danger mt-2" v-if="errors.type">{{ errors.type }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Solde</label>
              <input type="text" v-model="balance" class="form-control">
              <span class="text-danger mt-2" v-if="errors.balance">{{ errors.balance }}</span>
            </div>
            
            <div class="col-md-6 mb-3">
              <label for="">Disponible</label>
              <input type="text" v-model="available" class="form-control">
              <span class="text-danger mt-2" v-if="errors.available">{{ errors.available }}</span>
            </div>
              
            <div class="col-md-6 mb-3">
              <label for="">Aggregator</label>
              <select required v-model="aggregator_id" class="form-control">
                <option value=""></option>
                <template v-for="aggregator in aggregators" :key="aggregator.id">
                  <option :value="aggregator.id">{{ aggregator.name }}</option>
                </template>
              </select>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Methode</label>
              <select required v-model="method_id" class="form-control">
                <option value=""></option>
                <template v-for="method in methods" :key="method.id">
                  <option :value="method.id">{{ method.name }}</option>
                </template>
              </select>
            </div>

          </div>
          <div class="mt-3" v-if="!loading">
            <input type="submit" value="Enregistrer" class="btn btn-primary">
          </div>
          <div class="mt-3 text-center" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
    </b-modal>


    <!-- EDIT MODAL -->
    <b-modal
        v-model="doesEditOpen"
        id="modal-center"
        centered
        size="lg"
        title="Modifier un aggregateur méthode"
        title-class="font-18"
        hide-footer
        >
        <form @submit.prevent="editItem()">
          <div class="row">
            
            
            <div class="col-md-6 mb-3">
              <label for="">Montant</label>
              <input type="text" required v-model="amount" class="form-control">
              <span class="text-danger mt-2" v-if="errors.amount">{{ errors.amount }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Type</label>
              <select required v-model="type" class="form-control">
                <option value="deposit">Dépôt</option>
                <option value="withdraw">Retrait</option>
              </select>
              <span class="text-danger mt-2" v-if="errors.type">{{ errors.type }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Solde</label>
              <input type="text" v-model="balance" class="form-control">
              <span class="text-danger mt-2" v-if="errors.balance">{{ errors.balance }}</span>
            </div>
            
            <div class="col-md-6 mb-3">
              <label for="">Disponible</label>
              <input type="text" v-model="available" class="form-control">
              <span class="text-danger mt-2" v-if="errors.available">{{ errors.available }}</span>
            </div>
              
            <div class="col-md-6 mb-3">
              <label for="">Aggregator</label>
              <select required v-model="aggregator_id" class="form-control">
                <option value=""></option>
                <template v-for="aggregator in aggregators" :key="aggregator.id">
                  <option :value="aggregator.id">{{ aggregator.name }}</option>
                </template>
              </select>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Methode</label>
              <select required v-model="method_id" class="form-control">
                <option value=""></option>
                <template v-for="method in methods" :key="method.id">
                  <option :value="method.id">{{ method.name }}</option>
                </template>
              </select>
            </div>
            
          </div>
          <div class="mt-3" v-if="!loading">
            <input type="submit" value="Enregistrer" class="btn btn-primary">
          </div>
          <div class="mt-3 text-center" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
    </b-modal>


    <!-- DELETE MODAL -->
    <b-modal
        v-model="doesDeleteOpen"
        id="modal-center"
        title="Supprimer un échange"
        title-class="font-18"
        hide-footer
        >
        <p class="mb-2">
            Voulez-vous vraiment supprimer l'échange <b>{{ aggregator_summarie?.from?.name }} - {{ aggregator_summarie?.to?.name }}</b> ?
        </p>
        <div class="hstack mt-2" v-if="!loading">
          <button class="btn btn-dark ms-auto" @click="doesDeleteOpen = false">Annuler</button>
          <button class="ms-3 btn btn-danger" @click="deleteIt()">Supprimer</button>
        </div>
        <div class="text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
    </b-modal>


  </Layout>
</template>
